import { TicketConfirmationOutlineIcon } from './TicketConfirmationOutlineIcon';

/**
 * author: Google
 * id A1B45743-22F5-49E8-B466-120024F2C4C3
 * name ticket-confirmation-outline
 * version: 5.0.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ticket-confirmation-outline.svg
 * tags
 */
export const ConfirmationNumberOutlineIcon = TicketConfirmationOutlineIcon;
export default ConfirmationNumberOutlineIcon